import ButtonStyles from "./Buttons.module.scss";

import driveIcon from "../../assets/images/googleDriveLogo.svg";
import uploadSvg from "../../assets/images/UploadIcon.svg";
import bookSparkSVG from "../../assets/book_spark.svg";
import uploadContractBlueSvg from "../../assets/upload_contract_blue.svg";

import Button from "../Button/Button";
import { LoadingButtonProps } from "@mui/lab";
import Typography from "../Typography/Typography";
import { ButtonProps } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React from "react";

export const ChooseFromDriveBtn = ({
  onClick,
  loading,
  disabled,
  fullWidth,
}: LoadingButtonProps) => {
  return (
    <Button
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      variant="outlined"
      startIcon={<img src={driveIcon} alt="" width="23px" />}
      style={{
        borderRadius: "24px",
        border: "1px solid #3474E0",
        padding: "4px 16px",
      }}
      fullWidth={fullWidth}
      loadingPosition="start"
    >
      <Typography
        style={{ padding: "4px 0px" }}
        color="#3474E0"
        fontWeight={500}
        fontSize={12}
        ellipsis={true}
      >
        Choose From Drive
      </Typography>
    </Button>
  );
};

export const SimpleButton = ({
  onClick,
  disabled,
  variant = "outlined",
  style,
  children,
  size = "small",
}: ButtonProps) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      size={size}
      style={style}
    >
      {children}
    </Button>
  );
};

export const UploadBtn = ({
  onClick,
  variant = "contained",
  disabled,
  loading,
  children,
  startIcon,
}: LoadingButtonProps) => {
  const styles = {
    borderRadius: "24px",
    padding: "4px 16px",
  };
  return (
    <Button
      onClick={onClick}
      variant={variant}
      disabled={disabled}
      loading={loading}
      startIcon={
        startIcon ? startIcon : null
        // <img style={{ height: "20px" }} src={UploadSVG} alt="" />
      }
      style={
        disabled ? { backgroundColor: "#E8E8E8", ...styles } : { ...styles }
      }
    >
      {children ? (
        children
      ) : (
        <Typography style={{ padding: "4px 0px", fontSize: "12px" }}>
          Upload
        </Typography>
      )}
    </Button>
  );
};

interface UploadButtonProps {
  onClick: () => void;
  loading?: boolean;
  disabled: boolean;
  fullWidth: boolean;
  navigate: ReturnType<typeof useNavigate>;
}

export const UploadFileFromDriveBtn = ({
  onClick,
  disabled,
  fullWidth,
}: UploadButtonProps) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant="outlined"
      endIcon={<img src={driveIcon} alt="" width="23px" />}
      style={{
        background: "#FFFFFFB2",
        border: "1px solid #E2E2E2",
        borderRadius: "138px",
        justifyContent: "space-between",
        padding: "16px 24px",
        boxShadow: "0px 8px 24px 0px #00000014",
      }}
      fullWidth={fullWidth}
      loadingPosition="end"
    >
      <div style={{ width: "24px", height: "24px", marginRight: "8px" }}>
        <img src={bookSparkSVG} alt="book spark" />
      </div>
      <Typography style={{ padding: "4px 0px" }} color="#767680">
        Upload files from Google Drive to enter the chat...
      </Typography>
    </Button>
  );
};

export const DriveBtn = ({
  onClick,
  loading,
  disabled,
  fullWidth,
}: LoadingButtonProps) => {
  return (
    <Button
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      variant="outlined"
      endIcon={<img src={driveIcon} alt="" width="23px" />}
      fullWidth={fullWidth}
      loadingPosition="end"
      style={{
        border: "none",
      }}
    ></Button>
  );
};

export const UploadFileFromDriveBtnTtcChat = ({
  onClick,
  loading,
  disabled,
  fullWidth,
}: LoadingButtonProps) => {
  return (
    <Button
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      variant="outlined"
      // endIcon={<img src={driveIcon} alt="" width="23px" />}
      style={{
        background: "#FFFFFFB2",
        border: "1px solid #E2E2E2",
        borderRadius: "138px",
        justifyContent: "space-between",
        padding: "10px 18px",
        boxShadow: "0px 8px 24px 0px #00000014",
      }}
      fullWidth={fullWidth}
      loadingPosition="end"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ width: "24px", height: "24px", marginRight: "8px" }}>
          <img src={bookSparkSVG} alt="book spark" />
        </div>
        <Typography
          style={{ padding: "4px 0px" }}
          color="#767680"
          ellipsis={true}
        >
          Upload files from Google Drive to enter the chat...
        </Typography>
      </div>
    </Button>
  );
};

interface UploadActionBtnProps {
  text?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  style?: React.CSSProperties;
  variant?: "text" | "outlined" | "contained" | undefined;
  disabled?: boolean;
  icon?: React.ReactNode;
  color?: string;
}

export const UploadActionBtn: React.FC<UploadActionBtnProps> = ({
  text = "Upload",
  onClick,
  style,
  variant,
  disabled,
  icon,
  color,
}) => {
  const isOutlined = variant === "outlined";
  return (
    <Button
      className={ButtonStyles.uploadActionBtn}
      onClick={onClick}
      style={{
        padding: "6px 16px",
        ...style,
      }}
      variant={variant}
      disabled={disabled}
    >
      <div className={ButtonStyles.uploadActionBtnText}>
        {icon ? (
          icon
        ) : (
          <img
            src={isOutlined ? uploadContractBlueSvg : uploadSvg}
            alt="Upload"
            height={16}
            width={16}
          />
        )}
        <Typography
          fontSize={12}
          fontWeight={500}
          ellipsis={true}
          color={color}
        >
          {text}
        </Typography>
      </div>
    </Button>
  );
};
